var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.visibleContent),function(element,index){return _c(_vm.getElementComponent(element),_vm._b({key:`content_element_${index}`,tag:"component",attrs:{"data":element}},'component',{ ...element.properties },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }